import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "ddf26364-eaa6-4ca2-b420-d72a57bb7ea9",
  publicId: "9",
  name: "Electrodynamic transduction",
  difficulty: 2,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, task01, task02, task03],
};

export default lesson;
